import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a6eef60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminAccommodationInquiries = _resolveComponent("AdminAccommodationInquiries")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, { class: "accommodation-table-container pa-6 elevation-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_AdminAccommodationInquiries, {
          accommodationInquiries: _ctx.accommodationInquiries,
          onInquiryCreated: _ctx.fetchData
        }, null, 8, ["accommodationInquiries", "onInquiryCreated"])
      ]),
      _: 1
    })
  ]))
}